import { getRandomUid } from 'utilities/uuid.service';
import { useEffect, useState } from 'react';
import useDebounce from 'hooks/useDebounce';
import { AsyncTypeahead } from 'react-bootstrap-typeahead';
import useLessons from 'hooks/API/GET/useLessons';

function LessonsSearch({ enableAPI, isMulti, values, handleChange, dependencies = {} }) {
  const { query = {}, classID, courseID, chapterID } = dependencies;
  const [topics, setTopics] = useState([]);
  const [search, setSearch] = useState('');
  const [keyword, setKeyword] = useState('');

  const _id = getRandomUid();

  const { data, isLoading } = useLessons({
    enabled: enableAPI,
    classID,
    courseID,
    chapterID,
    configs: { params: { mode: 'dropdown', keyword, ...query } },
  });

  useEffect(() => {
    if (data?.data) setTopics(data?.data || []);

    return () => {};
  }, [data?.data]);

  const __search = useDebounce(search, 1000);

  useEffect(() => {
    if (__search) setKeyword(__search);
  }, [__search]);

  return (
    <>
      <label htmlFor={_id}>Lessons </label>
      <AsyncTypeahead
        id={_id}
        filterBy={() => true}
        isLoading={isLoading}
        labelKey="name"
        // minLength={3}
        onSearch={(query) => setSearch(query)}
        options={topics}
        placeholder="Search lessons..."
        selected={values}
        onChange={handleChange}
        renderMenuItemChildren={(option) => <>{option.name}</>}
        useCache={false}
      />
    </>
  );
}

LessonsSearch.defaultProps = {
  values: [],
  isMulti: false,
  handleChange: () => {},
};

export default LessonsSearch;
